var _excluded = ["title", "titleProps", "text", "className"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from 'react';
import c from 'classnames';
import WysiwygField from '../WysiwygField';
var TitleWithText = function TitleWithText(_ref) {
  var title = _ref.title,
    titleProps = _ref.titleProps,
    text = _ref.text,
    className = _ref.className,
    props = _objectWithoutProperties(_ref, _excluded);
  var classes = c('TitleWithText', className);
  return /*#__PURE__*/React.createElement("div", {
    className: classes
  }, title && /*#__PURE__*/React.createElement("h2", _extends({
    className: "TitleWithText__title"
  }, titleProps), title), text && /*#__PURE__*/React.createElement(WysiwygField, _extends({
    className: "TitleWithText__text",
    property: "schema:text"
  }, props, {
    html: text
  })));
};
export default TitleWithText;